'use client';

import React from 'react';

// npm packages
import Image from 'next/image';
import Link from 'next/link';

// components
import { brands } from '@/constants/list';
import Text from '../Text';
import ImageComponentV2 from '../Image/ImageComponentV2';

// utils

function NavigationBrandsSecondary() {
  return (
    <section className="bg-white pb-[100px] pt-[28px]">
      <div className="space-y-[14px] !mb-[14px]">
        <div className="bg-pale-grey w-full h-[58px] flex justify-center items-center rounded-xl px-16 py-8 shadow-trending-categories-search">
          <Link prefetch={false} aria-label="Go to singer brand" href="#">
            <ImageComponentV2
              src="/icons/singer-red.svg"
              width={200}
              height={28}
              objectFit="cover"
              alt="singer"
            />
            {/* <Icon type="singeronly" color={RED_HOT} /> */}
          </Link>
        </div>
        <div className="bg-pale-grey w-full h-[58px] flex justify-center items-center rounded-xl px-16 py-8 shadow-trending-categories-search">
          <Link prefetch={false} aria-label="Go to beko brand" href="#">
            <ImageComponentV2
              src="/icons/beko.svg"
              width={73}
              height={42}
              objectFit="cover"
              alt="beko"
            />
          </Link>
        </div>
        <div className="bg-pale-grey w-full h-[58px] flex justify-center items-center rounded-xl px-16 py-8 shadow-trending-categories-search">
          <Link prefetch={false} aria-label="Go to hitachi brand" href="#">
            <Image
              src="/icons/hitachi-black.svg"
              width={175}
              height={28}
              objectFit="cover"
              alt="hitachi"
            />
          </Link>
        </div>
      </div>
      <ul className="flex flex-wrap justify-center gap-y-[14px] gap-x-[10px]">
        {brands?.map((item) => (
          <li
            key={item?.id}
            className="flex flex-grow flex-shrink basis-2/12 justify-center min-w-[90px] max-w-[105px] bg-pale-grey rounded-xl shadow-trending-categories-search"
          >
            <Link
              prefetch={false}
              aria-label="Go to brand secondary menu item"
              href="#"
              className="w-full h-full flex flex-col items-center gap-[4px] p-8"
            >
              <Text
                type="span"
                className="text-12 text-coarse-wool text-center font-encode-sans font-semibold leading-14 tracking-[0.24px] line-clamp-2"
              >
                {item.name}
              </Text>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default NavigationBrandsSecondary;
